import { CrudConsumer, CrudConsumerObject } from "consumerjs";
import { API_KEY, getApiBaseEndpoint } from "./api";

/**
 * Background question answer.
 */
class BackgroundQuestionAnswer extends CrudConsumerObject {}

/**
 * Background question answer consumer.
 */
export class BackgroundQuestionAnswerConsumer extends CrudConsumer {
    constructor(
        endpoint = `${getApiBaseEndpoint()}/background-answers/`,
        objectClass = BackgroundQuestionAnswer,
        options = { csrfProtection: false }
    ) {
        super(endpoint, objectClass, options);

        this.addHeader("AUTHORIZATION", API_KEY);
    }

    /**
     * Sets the language.
     * @param {Object} language
     */
    setLanguage(language) {
        this.endpoint = `${getApiBaseEndpoint(language)}/background-answers/`;
    }

    /**
     * Sets the session header.
     * @param {Session} session
     */
    setSession(session) {
        this.addHeader("x-sessionid", session.session);
    }
}
